import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        margin-bottom: 15px;
        body {
            background: transparent;
        }
        font-weight: 500;
        letter-spacing: 1px;
        font-size: 16px;
    `,
};
